import { apiCallStatus } from 'helpers/constants';
import { CLEAR_STORE, DELETE_ASSET } from './constants';

const initialState = {
    loadingStatus: null,
    data: null,
    error: null
};

export function DeleteAssetReducer(state = initialState, action) {
    switch (action.type) {
        case DELETE_ASSET:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            break;
        case CLEAR_STORE:
            return initialState;
        default:
            return state;
    }
}
